import { useContext, useState, useEffect, useReducer } from 'react'
import { Grid, Box } from '@mui/material'
import { listArticles } from './data/index.js'
import { getSiteConfigRoutes } from '../community/siteProvider'
import SmallArticleList from "./ArticleComponents/SmallArticleList.js";

export default function HomePageCarousel(props = {}) {

  const [allArticles, setAllArtices] = useState([])

  const initialState = {
    // '{sitedId}': {
    //   loading: false,
    //   loadingMore: false,
    //   articles: [],
    //   totalAvailable: undefined,
    //   totalLoaded: 0,
    //   nextToken: undefined,
    // }
  }

  function articleReducer(state, action) {
    const _state = structuredClone(state)
    const [siteId, key, value] = action
    _state[siteId] = _state[siteId] || {}
    _state[siteId][key] = value

    return _state
  }

  const [newsMap, dispatchNews] = useReducer(articleReducer, initialState)

  useEffect(() => {
    const siteConfigs = getSiteConfigRoutes();

    siteConfigs.map(async siteConfig => {
      const { siteId, sitePath } = siteConfig
      for await (const articlesResponse of listArticles(
        { displayOnHomePage: true },
        true,
        0,
        undefined,
        200,
        false,
        siteConfig)
      ) {

        const { articles, totalSize, nextLink, totalLoaded } = articlesResponse
        if (articles) {
          const prevArticles = newsMap?.[siteId]?.articles || []
          const newArticles = [...prevArticles, ...articles].map(a => ({ ...a, sitePath }))
          dispatchNews([siteId, 'articles', newArticles])
          dispatchNews([siteId, 'totalAvailable', totalSize])
          dispatchNews([siteId, 'nextToken', nextLink])
          if (totalLoaded) dispatchNews([siteId, 'totalLoaded', totalLoaded])
        }
      }
    })

  }, [])

  useEffect(() => {
    const newArts = []
    for (const key of Object.keys(newsMap)) {
      console.log('key, newsMap[key].articles.length:', key, newsMap[key].articles.length)
      newArts.push(...newsMap[key].articles)
    }

    newArts.sort((a, b) => {
      const aOrder = Number(a?.metadata?.homePageDisplayOrder)
      const bOrder = Number(b?.metadata?.homePageDisplayOrder)

      const aHas = Number.isFinite(aOrder)
      const bHas = Number.isFinite(bOrder)

      // push missing/invalid orders to the end
      if (!aHas && !bHas) return 0
      if (!aHas) return 1
      if (!bHas) return -1

      return aOrder - bOrder
    })

    setAllArtices(newArts)
  }, [newsMap])

  return <>
    <Box >
      <Grid container gap={0} sx={{ position: 'relative', textAlign: 'left' }}>
        <Grid item xs={12}>
          <SmallArticleList
            articles={allArticles}
            loading={false}
            editable={false}
            published={false}
            news
            tilesPerRow={Math.min(allArticles.length, 3)}
            compact
            author={false}
            tags={false}
            justifyTiles='stretch'
          />
        </Grid>
      </Grid>
    </Box>
  </>
}